import Collectors from './components/Collectors';
export default Collectors;